// 每个页面需要被渲染的NAME集合
// 支部概况
const ProfileName = [
  // 支部简介 党委简介 共用接口
  'Abouts',
  // 组织架构  共用接口
  'Schema',
   // 组织部名册
  'PartyZuzhiMembers',
  // 党组织委员登记表 支部独有
  'CadreLists',
  // 党员风采 共用接口
  'PartyMien',
  // 党员风采 支部独有
  'PartyMembers',
  // 公司成员名册
  'MonicaLists',
  // 党员名册 支部独有
  'PrepareMembers',
  // 党委委员名册 党委独有
  'DWPartyMembers',
  // 积极分子 支部独有
  'ActivistMembers',
  // 预备党员 支部独有
  'PartyCirculation',
  // 入党申请者 支部独有
  'PartyMembership',
  // 拟发展对象名册 支部独有
  'PartyMemberapply',
  // 预备党员 支部独有
  'PartyCirCulationsOut',
  // 非党员名册 支部独有
  'PartyMemberNoapply',
  // 流动党员
  'PartyMemberOut'
]
// 组织生活
const OrganizeName = ['Creat', 'HistoryEvents']
// 活动简报
const EventRecordName = [
  'EventRecordComplete',
  'EventRecordCompleteEdit',
  'EventRecordCreat',
  'EventRecordDrafts',
  'EventRecordDraftsEdit',
]
// 文件管理+党员学习
const LearningName = [
  // 文件管理
  'FileManageMent',
  // 上级文件
  'SuperiorFile',
  // 添加学习计划
  'AddLearningPlan',
  // 学习计划列表
  'LearningPlanList',
  // 文件下发
  'SendFile',
  // 文件下发记录
  'SendFileRecord'

]
// 主题教育
const ThemeName = ['Theme']
// 党费收缴
const CollectMoneyName = [
  'CollectMoney',
  'CollectMoneyPerformRecord',
  'CollectMoneyTurnRecord',
  'CollectMoneyUseRecord',
  'DWCollectMoney'
]
// 资料查询
const DataQueryName = [
  // 'DataQuerySuperior',
  'DataQuerySystem',
  'DataQueryWorks'
]
// 典型案例
const CaseName = [
  'ChinaCase', //全国优秀工作案例
  //'HCCase', // 红潮党建案例
  'LocalCase' // 本地优秀案例
]
// 课件资源  CoursewarEventSigne
// const CoursewarEventSigneName = ['CoursewarEventSigne','Compulsory','Optional','ElectiveCourse']
const CoursewarEventSigneName = ['Compulsory', 'Optional', 'ElectiveCourse']
// 会议记录
const MeetingRecordName = [
  // 创建会议类型列表
  'CreatMeeting',
  // 创建会议表单页
  'CreatMeetingForm',
  // 进行中的会议列表
  'DoingMeetings',
  // 进行中的会议详情
  'DoingMeetingsActivity',
  // 历史会议记录
  'MeetingHistory',
  // 
  'MeetingType'
]

// 党内关爱
const CareName = ['CareHelp', 'ComplaintsBox', 'DiaryHistory', 'DiaryCreat', 'SpecialNeeds', 'RegistrationSheet']
// 党员发展
const PartyerGrowName = ['Growing', 'Waiting', 'formal']
const ComplaintsBoxName = ['ComplaintsBox']
// 支部管理
const BranchName = [
  'CollectMoneyStatistics',
  'ConferenceStatistics',
  'MemberStatistics',
  'AboutsStatistics',
  'SchemaStatistics',
  'CadreListsStatistics',
  // 'PartyMienStatistics',
  'Outmember',
  'PartyMembersStatistics',
  'PrepareMembersStatistics',
  'ActivistMembersStatistics',
  'MeetingHistorys',
  'MeetingHistoryDetail',
  'briefings',
  'briefingsDetail',
  'BranchHonor',
  'CollectMoneys',
  'SubBranchStatistics',
  'SubMainMeetingStatistics',
  'SubMeetingStatistics',
  'SubEventRecordStatistics',
  'SubPersonalTaskStatistics',
  'SubOrganizationTaskStatistics',
  'SubStudyAffairsStatistics',
  'SubPersonalPointsStatistics',
  'SubOrganizationPointsStatistics',
]

// 任务交办
const TaskName = [
  'TaskLeader',
  'TaskLeaderDetail',
  'TaskLeaderForm',
  'TaskBranchDetail'
]


// 管理中心
const ManageName = [
  'PastManager',
  'NowManager',
  'Statistics',
  'DataManagement',
  'Notice',
  'System',
  'password',
  'BranchManagement',
  'geographical',
  'BranchManagementAdd',
]

// 数据统计
const StatisticsName = [
  // 组织概况
  'BranchStatistics',
  // 三会一课
  'MainMeetingStatistics',
  // 会议统计
  'MeetingStatistics',
  //党务公开
  'EventRecordStatistics',
  // 个人任务
  'PersonalTaskStatistics',
  // 组织任务
  'OrganizationTaskStatistics',
  // 学习数据
  'StudyAffairsStatistics',
  // 个人积分
  'PersonalPointsStatistics',
  // 组织积分
  'OrganizationPointsStatistics'
]

// 党员示范岗
const DemonstrationName = [
  'Demonstration',
  'DemonstrationDrafts',
  'DemonstrationDraftsEdit',
  'DemonstrationAdd',
  'DemonstrationAddEdit'
]

// 组织邀请
const InvitationName = [
  'InvitationLink',
]

const WorkReportName = [
  'WorkReport',
  'WorkReportList',
  'WorkReportForm',
]

// 荣誉墙
const HonorWallName = [
  'HonorWall',
  'OrgHonor',
  'PersonHonor'
]

// 任务交办
const BranchTaskName = [
  'TaskRelease',
  'TaskReleaseList'
]

// 支部（我的任务）
const BranchMyTaskName = [
  'TaskBranch',
]

//党员、职工素质提高平台
const QualityTrainingName = [
  'TrainingList',
  'TrainingDetail',
  'QuestionBank',
  'ExamManagement',
  'GradeAnalysis',
]

//凝心聚力工作平台
const CheerShareName = [
  'LaborUnion',
  'Komsomol',
  'WomensWork',
  'ResourceList'
]
//三重一大决策管理
const DecisionManagementName = [
  'DecisionManagementCreat',
  'DecisionManagementRecord',
]

//数据大屏
const LargeScreenSetting = [
  'LargeScreenHome','Cooperate','JointConstruction','Devprocess','Typicalcases','Honor','PMDemonstration','HeroineDemonstration','GRDemonstration','TYDemonstration','building','Feature','FounderInfo','WebsiteData','FeatureVideo'
]



export default {
  InvitationName,
  BranchMyTaskName,
  BranchTaskName,
  HonorWallName,
  TaskName,
  DemonstrationName,
  WorkReportName,
  ProfileName,
  ManageName,
  OrganizeName,
  EventRecordName,
  LearningName,
  ThemeName,
  CollectMoneyName,
  DataQueryName,
  CaseName,
  CoursewarEventSigneName,
  MeetingRecordName,
  CareName,
  PartyerGrowName,
  BranchName,
  StatisticsName,
  // QualityTrainingName,
  CheerShareName,
  // DecisionManagementName,
  LargeScreenSetting
}



// WEBPACK FOOTER //
// ./src/router/RoutesGroup.js